/* eslint-disable no-console */

import { register } from 'register-service-worker'
import store from './store';

let isAsync = true;

try {
  eval('async () => {}');
} catch (e) {
  isAsync = false;
}

if (isAsync) {
  register(`${process.env.BASE_URL}sw.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updated() {
      console.log('New content is available; please refresh.')
      store.commit('setUpdateState', true)
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.')
      store.dispatch('setNetworkState', 'offline')
    },
    error(error) {
      console.error('Error during service worker registration:', error)
      store.commit('setSwSupport', false)
    }
  })
} else {
  console.error('Not support async/await')
  store.commit('setSwSupport', false)
}
